import { DrillType } from "./drill";
/**
 * ワークメーカーで使用可能なドリルタイプの配列
 */
export var WORK_MAKER_AVAILABLE_DRILL_TYPE = [
    DrillType.KOKUGO,
    DrillType.KANA,
    DrillType.CHUGAKU_KOKUGO,
    DrillType.SANSU,
    DrillType.CHUGAKU_SUGAKU,
    DrillType.RIKA,
    DrillType.SHAKAI,
    DrillType.CHUGAKU_RIKA,
    DrillType.CHUGAKU_CHIRI,
    DrillType.CHUGAKU_REKISHI,
    DrillType.CHUGAKU_KOUMIN,
    DrillType.CHUGAKU_ENDRILL,
];
/**
 * 小学と中学のドリルタイプを区切るライン
 * 既存ドリルフロントでは中学国語のsubjectIdをラインとしているが、subjectで取り扱うことが殆ど無いのでドリルタイプIDにて同等の値を用いる
 */
export var OVER_ELEMENTARY_BORDER_DRILL_TYPE = DrillType.CHUGAKU_KOKUGO;
/**
 * WorkSelectDialogのタブID
 */
export var WORK_SELECT_DIALOG_TAB_ID = {
    WORK: 'work',
    TEMPLATE: 'template',
};
/**
 * WorkSelectDialogのタブ
 */
export var WORK_SELECT_DIALOG_TABS = [
    { id: WORK_SELECT_DIALOG_TAB_ID.WORK, name: '作成したワーク' },
    { id: WORK_SELECT_DIALOG_TAB_ID.TEMPLATE, name: 'テンプレート' },
];
/**
 * WorkSelectDialogのタブIDであるか
 */
export function isWorkSelectDialogTabId(value) {
    var values = Object.values(WORK_SELECT_DIALOG_TAB_ID);
    return typeof value === 'string' && values.includes(value);
}
